import React from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  closeAllPoppers,
  openPopper,
  selectCurrentlyActivePopper,
} from "@/react/store/uiSlice";

export const usePopper = (key) => {
  const dispatch = useDispatch();
  const currentlyActivePopper = useSelector(selectCurrentlyActivePopper);

  return React.useMemo(
    () => ({
      isOpen: currentlyActivePopper === key,
      openByKey: () => dispatch(openPopper(key)),
      closeAll: () => dispatch(closeAllPoppers()),
    }),
    [currentlyActivePopper, dispatch, key]
  );
};
